import { Box, Button, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../components/Translate/TranslateContext";
import { sendVerificationCode, verifyEmailCode } from "../../api/userRegistration";

export default function EmailVerification({ user, setUser }) {
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [resending, setResending] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (user?.user_id) sendVerificationCode(user.user_id).catch(() => setError("verification_send_failed"));
    }, [user?.user_id]);

    const handleVerify = async () => {
        setError("");
        setLoading(true);
        try {
            const result = await verifyEmailCode(user.user_id, code);
            if (!result.success) throw new Error(result.message || "verification_failed");
            setUser({ ...user, account_status: "active", email_verified: true });
            navigate("/dashboard");
        } catch (err) {
            setError(err?.response?.data?.message || err.message || "verification_failed");
        } finally {
            setLoading(false);
        }
    };

    const handleResend = async () => {
        setError("");
        setResending(true);
        try {
            await sendVerificationCode(user.user_id);
        } catch (err) {
            setError(err?.response?.data?.message || "verification_send_failed");
        } finally {
            setResending(false);
        }
    };

    return (
        <Box sx={{ px: { xs: 3, md: 6 }, py: 6, display: "flex", flexDirection: "column", alignItems: "center", gap: 3, textAlign: "center" }}>
            <Typography variant="h4">{translate("verify_email")}</Typography>

            <Typography sx={{ opacity: 0.8, maxWidth: 520 }}>
                {translate("verification_code_sent")}
            </Typography>

            <TextField
                label={translate("verification_code")}
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
                inputProps={{ inputMode: "numeric", maxLength: 6 }}
                sx={{ width: 260 }}
            />

            {error && (
                <Typography sx={{ color: "var(--color-green-strong)", fontSize: 14 }}>
                    {translate(error)}
                </Typography>
            )}

            <Button variant="contained" size="large" onClick={handleVerify} disabled={loading || code.length !== 6} sx={{ minWidth: 240 }}>
                {translate("verify_email")}
            </Button>

            <Button variant="text" onClick={handleResend} disabled={resending}>
                {translate("resend_code")}
            </Button>
        </Box>
    );
}